/**
 * Fabpad Find your fit quiz — branching, routing, result page.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'fabpad_quiz_v2';
  var TOTAL_MARKED = 5;
  var ANIM_MS = 220;

  var PRODUCTS = {
    clothPantyliners: {
      handle: 'reusable-cloth-pantyliners-pack-of-3',
      name: 'Reusable Cloth Pantyliners',
      subtitle: 'Washable light protection for spotting and daily freshness',
      isUnderwear: false,
      bullets: [
        'Washable over 100 times with proper care',
        'Ultra-thin for everyday wear without bulk',
        'No synthetic materials against your skin'
      ]
    },
    clothPads: {
      handle: 'reusable-cloth-pads-pink-pack-of-4',
      name: 'Reusable Cloth Pads',
      subtitle: 'Soft, washable pads for light to heavy flow days',
      isUnderwear: false,
      bullets: [
        'Built to last for years with regular washing',
        'Soft organic cotton against skin',
        'Less waste and less spend every cycle'
      ]
    },
    hipster: {
      handle: 'reusable-period-panties',
      name: 'Period Panty Hipster',
      subtitle: 'Everyday mid-rise coverage for medium flow',
      isUnderwear: true,
      bullets: [
        'Leakproof barrier that holds through the day',
        'Looks and feels like regular underwear',
        'Washable and reusable for up to 3 years'
      ]
    },
    midWaist: {
      handle: 'reusable-period-panties',
      name: 'Period Panty Mid Waist',
      subtitle: 'Reliable mid-rise coverage for office and home days',
      isUnderwear: true,
      bullets: [
        'Comfortable all-day wear under work clothes',
        'Absorbency for medium flow without pads',
        'Reusable for up to 3 years with care'
      ]
    },
    highWaist: {
      handle: 'fabpad-reusable-high-waist-period-urine-incontinence-postpartum-panties-underwear-lasts-for-up-to-3-years',
      name: 'Period Panty High Waist',
      subtitle: 'Full coverage for heavy flow and high-confidence days',
      isUnderwear: true,
      bullets: [
        'Higher waistband for fuller coverage',
        'Built for heavy flow and overnight protection',
        'Also supports light bladder leaks and postpartum'
      ]
    },
    ecoHighWaist: {
      handle: 'fabpad-eco-high-waist-period-panty-100-cotton-leak-proof-reusable',
      name: 'Eco High Waist Period Panty',
      subtitle: '100% cotton high-rise for heavy days and postpartum',
      isUnderwear: true,
      isNew: true,
      bullets: [
        'Breathable 100% cotton high-waist fit',
        '5-layer core holds up to 8 ml / 4 pads',
        'Change every 6–8 hours; reusable up to 100 washes'
      ]
    },
    shorties: {
      handle: 'fabpad-reusable-leak-proof-period-shorties-panty-underwear-for-heavy-flow-urine-incontinence-boy-shorts-style',
      name: 'Period Panty Shorties',
      subtitle: 'Boy-short coverage for active days and light leaks',
      isUnderwear: true,
      bullets: [
        'Extra coverage that stays put during movement',
        'Handles light bladder leaks discreetly',
        'Looks like regular shorties, not medical wear'
      ]
    },
    teen: {
      handle: 'reusable-period-panties-teen',
      name: 'Teen Period Panty',
      subtitle: 'Designed for younger bodies — easy as regular underwear',
      isUnderwear: true,
      bullets: [
        'As easy to wear as everyday underwear',
        'No applicator, cup, or learning curve',
        'Comfortable fit for teens starting periods'
      ]
    },
    organicPantyliners: {
      handle: 'organic-cotton-disposable-pantyliners-pack-of-40',
      name: 'Organic Cotton Pantyliners (Pack of 40)',
      subtitle: 'Plastic-free liners for spotting and lighter days',
      isUnderwear: false,
      bullets: [
        'Organic cotton surface, no plastic layers',
        'Gentle enough for daily and sensitive skin use',
        'Use and throw, no washing'
      ]
    },
    organicPads280: {
      handle: 'cotton-disposable-sanitary-pads',
      name: 'Cotton Sanitary Pads 280mm',
      subtitle: 'Medium-flow cotton sanitary pads with wings',
      isUnderwear: false,
      variantMatch: '280',
      bullets: [
        '280mm length for medium flow days',
        'Ultra-soft cotton top sheet',
        '7-layer absorbent core with Japanese SAP'
      ]
    },
    organicPads330: {
      handle: 'cotton-disposable-sanitary-pads',
      name: 'Cotton Sanitary Pads 320mm',
      subtitle: 'Heavy-flow cotton sanitary pads with wings',
      isUnderwear: false,
      variantMatch: '320',
      bullets: [
        '320mm length for heavy and overnight flow',
        'Ultra-soft cotton top sheet',
        'Secure wings for overnight protection'
      ]
    },
    disposablePanties: {
      handle: 'fabpad-ultra-absorbent-disposable-use-throw-period-panties-pack-of-10',
      name: 'Disposable Period Panties',
      subtitle: 'Use-and-throw coverage for heavy or recovery days',
      isUnderwear: false,
      bullets: [
        'High absorbency for heavy flow or postpartum',
        'No washing required — wear and dispose',
        'Discreet underwear-style coverage'
      ]
    },
    detergent: {
      handle: 'fabpad-liquid-detergent-wash-removes-period-stains-gentle-clean-for-reusable-period-panties-cloth-pads-500-ml',
      name: 'Liquid Detergent for Reusables',
      subtitle: 'Gentle wash made for period panties and cloth pads',
      isUnderwear: false,
      bullets: []
    },
    intimateWash: {
      handle: 'fabpad-gentle-intimate-wash-for-women-ph-balanced-fragrance-free-daily-feminine-hygiene-cleanser-100ml',
      name: 'Gentle Intimate Wash',
      subtitle: 'pH-balanced daily cleanser for intimate care',
      isUnderwear: false,
      bullets: []
    },
    breastPads: {
      handle: 'maternity-and-nursing-breast-pads-pack-of-12',
      name: 'Maternity Breast Pads',
      subtitle: 'Soft, absorbent pads for nursing and leaking',
      isUnderwear: false,
      bullets: []
    },
    mensBriefs: {
      handle: 'fabpad-mens-reusable-leakproof-accidental-urine-incontinence-leakage-underwear-briefs',
      name: "Men's Incontinence Underwear (Briefs)",
      subtitle: 'Also available for men',
      isUnderwear: true,
      bullets: []
    },
    mensTrunks: {
      handle: 'fabpad-men-s-reusable-incontinence-trunks-leakproof-boxer-briefs-for-urine-leakage',
      name: "Men's Incontinence Trunks",
      subtitle: 'Also available for men',
      isUnderwear: true,
      bullets: []
    }
  };

  var QUESTIONS = {
    q1: {
      id: 1,
      key: 'q1',
      heading: 'What brings you here today?',
      options: [
        { value: 'switcher', label: 'I want to switch from disposable pads to something reusable' },
        { value: 'already_reusables', label: 'I already use reusables and want to try Fabpad' },
        { value: 'cleaner', label: 'I want cleaner disposable pads without plastic' },
        { value: 'incontinence', label: 'I am managing bladder leaks or light incontinence' },
        { value: 'postpartum', label: 'I am postpartum or pregnant' },
        { value: 'teen', label: 'I am buying for my daughter or a teenager' }
      ]
    },
    q2: {
      id: 2,
      key: 'q2',
      heading: 'How would you describe your flow on your heaviest day?',
      options: [
        { value: 'light', label: 'Light', sub: 'Barely need protection, mostly spotting.' },
        { value: 'medium', label: 'Medium', sub: 'Manageable, change a pad every few hours.' },
        { value: 'heavy', label: 'Heavy', sub: 'Go through pads quickly, sometimes overflow.' },
        { value: 'very_heavy', label: 'Very heavy', sub: 'Overnight pads during the day, frequent leaks.' }
      ]
    },
    q3: {
      id: 3,
      key: 'q3',
      heading: 'Which of these fits where you are right now?',
      options: [
        { value: 'regular', label: 'Managing a regular adult cycle' },
        { value: 'perimenopausal', label: 'Perimenopausal, my cycle is changing' },
        { value: 'postpartum_stage', label: 'Postpartum, recovering after birth' },
        { value: 'active_life', label: 'Active and on the go most days' }
      ]
    },
    q4: {
      id: 4,
      key: 'q4',
      heading: 'What does a typical day look like for you?',
      options: [
        { value: 'active', label: 'Active — gym, sports, or lots of movement' },
        { value: 'office', label: 'Office or working from home' },
        { value: 'travel', label: 'Travelling frequently or long commutes' },
        { value: 'home', label: 'Mostly at home' }
      ]
    },
    q5: {
      id: 5,
      key: 'q5',
      heading: 'What matters most to you?',
      options: [
        { value: 'zero_leaks', label: 'Zero leaks, that is the priority' },
        { value: 'sustainability', label: 'Something sustainable and planet-friendly' },
        { value: 'saving', label: 'Saving money long term' },
        { value: 'comfort', label: 'The most comfortable option' },
        { value: 'ease', label: 'Easy to use, no learning curve' }
      ]
    }
  };

  var root = document.querySelector('[data-fabpad-quiz]');
  if (!root) return;

  var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var phaseIntro = root.querySelector('[data-quiz-phase="intro"]');
  var phaseQuestions = root.querySelector('[data-quiz-phase="questions"]');
  var phaseResult = root.querySelector('[data-quiz-phase="result"]');
  var progressFill = root.querySelector('[data-quiz-progress-fill]');
  var counterEl = root.querySelector('[data-quiz-counter]');
  var pctEl = root.querySelector('[data-quiz-pct]');
  var slideTrack = root.querySelector('[data-quiz-slide-track]');
  var questionEl = root.querySelector('[data-quiz-question]');
  var backBtn = root.querySelector('[data-quiz-back]');
  var startBtn = root.querySelector('[data-quiz-start]');
  var retakeBtn = root.querySelector('[data-quiz-retake]');

  var state = loadState();
  var resultProduct = null;

  function defaultState() {
    return {
      phase: 'intro',
      pathIndex: 0,
      answers: { q1: null, q2: null, q3: null, q4: null, q5: null },
      completed: false
    };
  }

  function loadState() {
    try {
      var saved = sessionStorage.getItem(STORAGE_KEY);
      if (saved) {
        var parsed = JSON.parse(saved);
        parsed.answers = Object.assign(defaultState().answers, parsed.answers || {});
        return parsed;
      }
    } catch (e) { /* ignore */ }
    return defaultState();
  }

  function saveState() {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    } catch (e) { /* ignore */ }
  }

  function clearState() {
    state = defaultState();
    sessionStorage.removeItem(STORAGE_KEY);
  }

  function escapeHtml(str) {
    if (!str) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents);
    }
    return '₹' + (cents / 100).toLocaleString('en-IN', { maximumFractionDigits: 0 });
  }

  function isReusablePath(q1) {
    return q1 === 'switcher' || q1 === 'already_reusables';
  }

  function isFlowPath(q1) {
    return isReusablePath(q1) || q1 === 'cleaner';
  }

  /** Build ordered question keys for the current answers. */
  function buildPath(answers) {
    var path = ['q1'];
    var q1 = answers.q1;

    if (!q1) return path;

    if (q1 === 'postpartum' || q1 === 'teen') {
      path.push('q5');
      return path;
    }

    if (q1 === 'incontinence') {
      path.push('q4', 'q5');
      return path;
    }

    // switcher / already_reusables / cleaner
    path.push('q2');
    if (isFlowPath(q1)) path.push('q3');
    path.push('q4', 'q5');
    return path;
  }

  function currentKey() {
    var path = buildPath(state.answers);
    return path[state.pathIndex] || 'q1';
  }

  function getWhyCopy(answers) {
    var q1 = answers.q1;
    var q2 = answers.q2;
    var q5 = answers.q5;

    if (q1 === 'postpartum') {
      return 'Safe for postpartum bleeding and light incontinence. Gentle on sensitive postpartum skin.';
    }

    if (q1 === 'teen') {
      if (q5 === 'ease') {
        return 'As easy to wear as regular underwear. No applicator, no cup, no learning curve needed.';
      }
      return 'Designed for younger bodies and first periods. Comfortable, discreet, and simple to use.';
    }

    if (q1 === 'incontinence') {
      if (q5 === 'zero_leaks') {
        return 'Absorbs light bladder leaks through the day. Looks and feels like regular underwear.';
      }
      if (q5 === 'comfort') {
        return 'Breathable, soft, and designed to be worn all day without bulk or discomfort.';
      }
      return 'Discreet protection for light bladder leaks. Everyday underwear comfort, with a leakproof barrier.';
    }

    if (q1 === 'cleaner') {
      if (q5 === 'sustainability') {
        return 'Ultra-soft cotton top sheet with a 7-layer absorbent core. Wrap it in the disposal cover and bin it after use.';
      }
      if (q5 === 'comfort') {
        return 'Ultra-soft cotton top sheet that is gentle on skin, free from added fragrance and dyes.';
      }
      return 'Simple disposable protection with an ultra-soft cotton top sheet for everyday comfort.';
    }

    // switcher / already_reusables
    if (q2 === 'medium' && q5 === 'zero_leaks') {
      return 'Built for medium flow days with a leakproof barrier that holds through the day. No anxiety, no overflow.';
    }
    if (q2 === 'medium' && q5 === 'sustainability') {
      return 'Washable over 100 times and lasts up to 3 years. One pair replaces hundreds of disposables over its lifetime.';
    }
    if (q2 === 'heavy' && q5 === 'zero_leaks') {
      return 'Built specifically for heavy flow days. Absorbs up to 35ml and holds through movement without leaking.';
    }
    if (q2 === 'heavy' && q5 === 'sustainability') {
      return 'Handles heavy flow and lasts up to 3 years with proper care. Less waste every cycle, permanently.';
    }
    if (q2 === 'light' && q5 === 'sustainability') {
      return 'Washable reusables for lighter days. Less waste every cycle without giving up comfort.';
    }
    if (q2 === 'very_heavy' && q5 === 'zero_leaks') {
      return 'Built for your heaviest days with high absorbency and a leakproof barrier you can trust.';
    }
    if (q5 === 'saving') {
      return 'A reusable option that pays for itself over time. Fewer monthly buys, more reliable protection.';
    }
    if (q5 === 'comfort') {
      return 'Soft against skin and designed to feel like regular underwear. Protection without the bulk.';
    }
    if (q5 === 'ease') {
      return 'Pull on like regular underwear. No applicator, no cup, no learning curve.';
    }
    return 'Matched to your answers for dependable protection that fits the way you live.';
  }

  function getRecommendation(answers) {
    var q1 = answers.q1;
    var q2 = answers.q2;
    var q4 = answers.q4;
    var primary;
    var crossSell;
    var crossSellLabel = 'Pairs well with';

    if (q1 === 'postpartum') {
      return {
        primary: PRODUCTS.highWaist,
        crossSell: PRODUCTS.disposablePanties,
        crossSellLabel: 'Also useful right now',
        why: getWhyCopy(answers)
      };
    }

    if (q1 === 'teen') {
      return {
        primary: PRODUCTS.teen,
        crossSell: PRODUCTS.clothPads,
        crossSellLabel: 'Pairs well with',
        why: getWhyCopy(answers)
      };
    }

    if (q1 === 'incontinence') {
      if (q4 === 'active') primary = PRODUCTS.shorties;
      else if (q4 === 'travel') primary = PRODUCTS.hipster;
      else primary = PRODUCTS.highWaist;

      return {
        primary: primary,
        crossSell: q4 === 'active' ? PRODUCTS.mensTrunks : PRODUCTS.mensBriefs,
        crossSellLabel: 'Also available for men',
        why: getWhyCopy(answers)
      };
    }

    if (q1 === 'cleaner') {
      if (q2 === 'light') primary = PRODUCTS.organicPantyliners;
      else if (q2 === 'medium') primary = PRODUCTS.organicPads280;
      else if (q2 === 'heavy') primary = PRODUCTS.organicPads330;
      else {
        primary = PRODUCTS.organicPads330;
        crossSell = PRODUCTS.disposablePanties;
      }

      return {
        primary: primary,
        crossSell: crossSell || PRODUCTS.intimateWash,
        crossSellLabel: crossSell ? 'Also consider' : 'Pairs well with',
        why: getWhyCopy(answers)
      };
    }

    // Reusable paths (switcher / already_reusables)
    if (q2 === 'light') {
      primary = PRODUCTS.clothPantyliners;
      crossSell = PRODUCTS.clothPads;
    } else if (q2 === 'medium') {
      if (q4 === 'office' || q4 === 'home') primary = PRODUCTS.midWaist;
      else primary = PRODUCTS.hipster;
      crossSell = PRODUCTS.detergent;
    } else if (q2 === 'heavy') {
      if (q4 === 'travel') primary = PRODUCTS.ecoHighWaist;
      else primary = PRODUCTS.highWaist;
      crossSell = PRODUCTS.detergent;
    } else if (q2 === 'very_heavy') {
      primary = PRODUCTS.highWaist;
      crossSell = PRODUCTS.ecoHighWaist;
    } else {
      primary = PRODUCTS.hipster;
      crossSell = PRODUCTS.detergent;
    }

    // Prefer path-specific cross-sell; detergent is default for other reusable results
    if (!crossSell) crossSell = PRODUCTS.detergent;

    return {
      primary: primary,
      crossSell: crossSell,
      crossSellLabel: crossSellLabel,
      why: getWhyCopy(answers)
    };
  }

  function fetchProduct(handle) {
    return fetch(rootPath + 'products/' + handle + '.js').then(function (res) {
      if (!res.ok) throw new Error('Product not found');
      return res.json();
    });
  }

  function firstAvailableVariant(product, matchText) {
    if (!product || !product.variants) return null;
    var list = product.variants;
    if (matchText) {
      var needle = String(matchText).toLowerCase();
      for (var i = 0; i < list.length; i++) {
        var title = (list[i].title || '').toLowerCase();
        if (title.indexOf(needle) !== -1 && list[i].available) return list[i];
      }
      for (var j = 0; j < list.length; j++) {
        if ((list[j].title || '').toLowerCase().indexOf(needle) !== -1) return list[j];
      }
    }
    for (var k = 0; k < list.length; k++) {
      if (list[k].available) return list[k];
    }
    return list[0] || null;
  }

  function showPhase(phase) {
    phaseIntro.hidden = phase !== 'intro';
    phaseQuestions.hidden = phase !== 'questions';
    phaseResult.hidden = phase !== 'result';
    state.phase = phase;
    saveState();
  }

  function updateProgress(questionId) {
    var pct = Math.round((questionId / TOTAL_MARKED) * 100);
    progressFill.style.width = pct + '%';
    counterEl.textContent = 'Question ' + questionId + ' of ' + TOTAL_MARKED;
    if (pctEl) pctEl.textContent = pct + '% complete';
    if (backBtn) backBtn.hidden = state.pathIndex === 0;
  }

  function renderQuestion() {
    var key = currentKey();
    var q = QUESTIONS[key];
    if (!q) return;

    updateProgress(q.id);

    var selected = state.answers[q.key];
    var optionsHtml = q.options.map(function (opt) {
      var isSelected = selected === opt.value;
      var sub = opt.sub
        ? '<span class="fabpad-quiz__option-sub">' + escapeHtml(opt.sub) + '</span>'
        : '';
      return (
        '<li>' +
        '<button type="button" class="fabpad-quiz__option' + (isSelected ? ' is-selected' : '') + '" data-quiz-option data-value="' + escapeHtml(opt.value) + '" role="radio" aria-checked="' + (isSelected ? 'true' : 'false') + '">' +
        '<span class="fabpad-quiz__option-radio" aria-hidden="true"></span>' +
        '<span class="fabpad-quiz__option-copy">' +
        '<span class="fabpad-quiz__option-label">' + escapeHtml(opt.label) + '</span>' +
        sub +
        '</span>' +
        '</button>' +
        '</li>'
      );
    }).join('');

    questionEl.innerHTML =
      '<h2 class="fabpad-quiz__heading">' + escapeHtml(q.heading) + '</h2>' +
      '<ul class="fabpad-quiz__options" role="radiogroup" aria-label="' + escapeHtml(q.heading) + '">' + optionsHtml + '</ul>';
  }

  function animateTransition(direction, callback) {
    var exitClass = direction === 'forward' ? 'is-exiting-left' : 'is-exiting-right';
    var enterClass = direction === 'forward' ? 'is-entering-right' : 'is-entering-left';

    slideTrack.classList.add(exitClass);
    setTimeout(function () {
      callback();
      slideTrack.classList.remove(exitClass);
      slideTrack.classList.add(enterClass);
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          slideTrack.classList.remove(enterClass);
        });
      });
    }, ANIM_MS);
  }

  function setResultImage(imgEl, placeholder, src, alt) {
    if (src) {
      imgEl.src = src;
      imgEl.alt = alt || '';
      imgEl.hidden = false;
      placeholder.hidden = true;
    } else {
      imgEl.hidden = true;
      placeholder.hidden = false;
    }
  }

  function showResultPhase(result) {
    showPhase('result');

    var nameEl = root.querySelector('[data-quiz-result-product-name]');
    var subtitleEl = root.querySelector('[data-quiz-result-subtitle]');
    var whyEl = root.querySelector('[data-quiz-result-why]');
    var bulletsEl = root.querySelector('[data-quiz-result-bullets]');
    var shopEl = root.querySelector('[data-quiz-primary-shop]');
    var imgEl = root.querySelector('[data-quiz-result-image]');
    var imgPlaceholder = root.querySelector('[data-quiz-result-image-placeholder]');
    var bundleEl = root.querySelector('[data-quiz-bundle]');
    var secondaryWrap = root.querySelector('[data-quiz-secondary]');
    var secondaryLabel = root.querySelector('[data-quiz-secondary-label]');

    var primary = result.primary;
    resultProduct = null;

    if (primary.isNew) {
      nameEl.innerHTML = escapeHtml(primary.name) + ' <span class="fabpad-nav__inline-badge fabpad-nav__inline-badge--new">New</span>';
    } else {
      nameEl.textContent = primary.name;
    }
    subtitleEl.textContent = primary.subtitle || '';
    whyEl.textContent = result.why || '';
    bulletsEl.innerHTML = (primary.bullets || []).map(function (b) {
      return '<li>' + escapeHtml(b) + '</li>';
    }).join('');

    shopEl.href = '/products/' + primary.handle;
    shopEl.textContent = 'View product';
    bundleEl.hidden = !primary.isUnderwear;

    fetchProduct(primary.handle).then(function (product) {
      resultProduct = product;
      setResultImage(imgEl, imgPlaceholder, product.featured_image, primary.name);
    }).catch(function () { /* image stays as placeholder */ });

    if (result.crossSell) {
      secondaryLabel.textContent = result.crossSellLabel || 'Pairs well with';
      populateSecondary(result.crossSell, secondaryWrap);
    } else {
      secondaryWrap.hidden = true;
    }
  }

  function populateSecondary(meta, wrap) {
    var nameEl = root.querySelector('[data-quiz-secondary-name]');
    var priceEl = root.querySelector('[data-quiz-secondary-price]');
    var shopEl = root.querySelector('[data-quiz-secondary-shop]');
    var imgEl = root.querySelector('[data-quiz-secondary-image]');
    var imgPlaceholder = wrap.querySelector('.fabpad-quiz__secondary-image-placeholder');

    fetchProduct(meta.handle).then(function (product) {
      wrap.hidden = false;
      if (meta.isNew) {
        nameEl.innerHTML = escapeHtml(meta.name || product.title) + ' <span class="fabpad-nav__inline-badge fabpad-nav__inline-badge--new">New</span>';
      } else {
        nameEl.textContent = meta.name || product.title;
      }
      var variant = firstAvailableVariant(product, meta.variantMatch);
      priceEl.textContent = variant ? formatMoney(variant.price) : formatMoney(product.price);
      if (shopEl) shopEl.href = '/products/' + (meta.handle || product.handle);
      if (product.featured_image) {
        imgEl.src = product.featured_image;
        imgEl.alt = product.title;
        imgEl.hidden = false;
        if (imgPlaceholder) imgPlaceholder.hidden = true;
      }
    }).catch(function () {
      wrap.hidden = true;
    });
  }

  function completeQuiz() {
    var result = getRecommendation(state.answers);
    state.completed = true;
    saveState();
    showResultPhase(result);
  }

  function goForward() {
    var path = buildPath(state.answers);
    if (state.pathIndex >= path.length - 1) {
      completeQuiz();
      return;
    }
    animateTransition('forward', function () {
      state.pathIndex += 1;
      // Rebuild path after answers may expand it (e.g. after Q1)
      var nextPath = buildPath(state.answers);
      if (state.pathIndex >= nextPath.length) state.pathIndex = nextPath.length - 1;
      saveState();
      renderQuestion();
    });
  }

  function goBack() {
    if (state.pathIndex === 0) return;
    animateTransition('backward', function () {
      state.pathIndex -= 1;
      saveState();
      renderQuestion();
    });
  }

  startBtn.addEventListener('click', function () {
    state.pathIndex = 0;
    state.completed = false;
    saveState();
    showPhase('questions');
    renderQuestion();
  });

  retakeBtn.addEventListener('click', function () {
    clearState();
    showPhase('intro');
  });

  var advancing = false;

  questionEl.addEventListener('click', function (e) {
    var option = e.target.closest('[data-quiz-option]');
    if (!option || advancing) return;

    var key = currentKey();
    var q = QUESTIONS[key];
    if (!q) return;

    var value = option.dataset.value;
    state.answers[q.key] = value;

    // Clear answers for questions that may no longer be on the path
    if (key === 'q1') {
      state.answers.q2 = null;
      state.answers.q3 = null;
      state.answers.q4 = null;
      state.answers.q5 = null;
    }

    questionEl.querySelectorAll('[data-quiz-option]').forEach(function (btn) {
      var on = btn === option;
      btn.classList.toggle('is-selected', on);
      btn.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    saveState();

    advancing = true;
    window.setTimeout(function () {
      goForward();
      advancing = false;
    }, 220);
  });

  if (backBtn) backBtn.addEventListener('click', goBack);

  if (state.completed && state.answers.q1) {
    showResultPhase(getRecommendation(state.answers));
  } else if (state.phase === 'questions' && (state.pathIndex > 0 || state.answers.q1)) {
    showPhase('questions');
    renderQuestion();
  } else {
    showPhase('intro');
  }
})();
